export default {
    hr: {
        header: [
            {
                title: 'Naslovna',
                path: '/',
                exact: true
            },
            {
                title: 'Usluge',
                path: '/usluge',
                exact: true
            },
            {
                title: 'Reference',
                path: '/reference',
                exact: true
            },
            {
                title: 'Kontakt',
                path: '/kontakt',
                exact: false
            },
            {
                title: 'O nama',
                path: '/onama',
                exact: true
            },
        ],
        landing: {
            title: 'bedrina projekt',
            title2: 'stvaramo domove',
            title3: 'gradimo objekte',
            text: 'Bedrina projekt brine o svim etapama razvoja objekta, uz vrhunsku podršku našim klijentima i investitorima, olakšavamo izgradnju i stvaramo zadovoljstvo.',
            button: 'saznaj više o nama',
            serviceTitle: 'naše usluge',
            serviceGrid: [
                {
                    icon: 'bed_architecture.png',
                    title: 'Projektiranje',
                    text: 'Definiramo zahtjeve klijenata, obuhvaćajući osam određenih stadija procesa planiranja i projektiranja, kako bismo uskladili projekt s traženim parametrima.',
                    link: '/usluge#projektiranje'
                },
                {
                    icon: 'bed_engineering.png',
                    title: 'Izgradnja',
                    text: 'Gradimo kuće, stanove, poslovne objekte, adaptiramo i rekonstruiramo postojeće prema najvišim standardima, nudeći cjelokupni spektar radova i izvedbe.',
                    link: '/usluge#gradevinarstvo'
                },
                {
                    icon: 'bed_oversight.png',
                    title: 'Nadzor',
                    text: 'Nadzor nad svim vrstama objekata visokogradnje temeljimo na usklađenosti s građevinskom dozvolom, glavnim projektom, zakonima te propisima i pravilima struke.',
                    link: '/usluge#nadzor'
                }
            ],
            serviceGridButton: 'Više o uslugama',
            handKeyTitle: 'SISTEM KLJUČ U RUKE',
            handKeyText: 'Razvijenim sistemom  Ključ u ruke, pružamo mogućnost kompletne izvedbe projekta, kako bi naručeni objekt bio spreman za konačnu uporabu, pružajući brigu o svim etapama izgradnje. Nudimo:',
            handKeyItems: [
                {
                    title: 'Kompletnu projektnu dokumentaciju',
                    items: ['Idejni projekt', 'Glavni projekt za ishođenje građevinske dozvole', 'Izvedbeni projekt', 'Troškovnik svih radova']
                },
                {
                    title: 'Kompletnu izvedbu svih radova',
                    items: ['Izvedbu svih navedenih radova iz stavki troškovnika do kompletne izvedenosti objekta', 'Tehnički pregled na osnovu kojeg se ishodi uporabna dozvola na osnovu koje se može koristiti građevina u potpunoj funkcionalnosti']
                }
            ],
            referencesTitle: 'reference',
            referencesButton: 'sve reference',
            handKeyButton: 'pošalji upit',
            poolInfo: {
                title: 'izgradnja bazena',
                subtitle: 'Jednostavna gradnja koja štedi vrijeme i novac',
                text: 'Sustavom "ključ u ruke" projektiramo i gradimo bazene od projekta do kompletne izvedbe sa svom opremom bazena.',
                speed: 'brža izrada',
                price: 'manja cijena',
                buttonText: 'saznaj više'
            }
        },
        services: {
            title: 'naše usluge',
            box1: {
                title: 'građevinarstvo',
                text: 'Bavimo se gradnjom, adaptacijom i rekonstrukcijom kuća, stanova, poslovnih objekata i objekata za tržište',
                image: '/images/el/bed_construction.png',
                button: 'pošalji upit',
                items: [
                    {
                        title: 'Zemljani radovi',
                        items: []
                    },
                    {
                        title: 'Armirački radovi',
                        items: []
                    },
                    {
                        title: 'Betonski i armiranobetonski radovi',
                        items: []
                    },
                    {
                        title: 'Tesarski radovi',
                        items: []
                    },
                    {
                        title: 'Krovopokrivački radovi',
                        items: []
                    },
                    {
                        title: 'Radovi na sanacijama',
                        items: []
                    },
                    {
                        title: 'Zidarski radovi',
                        items: []
                    },
                    {
                        title: 'Izolaterski radovi',
                        items: []
                    },
                    {
                        title: 'Završni radovi',
                        items: []
                    }
                ]
            },
            box2: {
                title: 'projektiranje',
                text: 'Bavimo se cjelokupnim arhitektonskim i građevinskim projektiranjem',
                image: '/images/el/bed_floorplan.png',
                button: 'pošalji upit',
                items: [
                    {
                        title: 'Idejno rješenje',
                        items: ['Podaci o smještaju građevine', 'Prostorni gabariti građevine', 'Funkcionalni i organizacijski raspored']
                    },
                    {
                        title: 'Idejni projekt',
                        items: ['Analiza podloga i uvjeta za gradnju', 'Razrada projektnog koncepta s grafičkim prikazima i analizama', 'Procjena troškova investicije']
                    },
                    {
                        title: 'Lokacijska dozvola',
                        items: []
                    },
                    {
                        title: 'Glavni projekt',
                        items: ['Izrada odabranog projektnog rješenja', 'Grafički prikaz cijelog objekta']
                    },
                    {
                        title: 'Građevinska dozvola',
                        items: []
                    }
                ]
            },
            box3: {
                title: 'nadzor',
                text: 'Bavimo se nadzorom nad svim vrstama objekata visokogradnje.',
                image: '/images/el/bed_helmet.png',
                button: 'pošalji upit',
                items: [
                    {
                        title: 'Projektantski nadzor',
                        items: ['Usklađenost građenja s građevinskom dozvolom', 'Usklađenost sa zakonom o gradnji', 'Usklađenost sa posebnim propisima i pravilima struke']
                    },
                    {
                        title: 'Nadzor nad građevinskim radovima',
                        items: ['Nadzor gradnje i kontrola ugrađenih materijala', 'Izrada obračuna izvedenih radova, kontrola količine materijala ugrađenog tijekom izgradnje objekta']
                    },
                    {
                        title: 'Konzultacije',
                        items: []
                    }
                ]
            },
            poolConstruction: {
                title: 'izgradnja bazena',
                text: 'Sustavom Ključ u ruke, projektiramo i gradimo bazene od početnog projekta do kompletne izvedbe bazena sa svim sadržajima.',
                items: [
                    {
                        title: 'Glavni projekt',
                        text: 'Glavni projekt uključuje arhitektonski projekt, građevinski projekt i projekt bazenske tehnike sa svom potrebnom dokumentacijom koja se dostavlja investitoru.',
                        img: 'bed_pool1-1.jpg'
                    },
                    {
                        title: 'Iskop i kostur',
                        text: 'Iskop bazena u svim kategorijama terena i tamponiranje dna bazena i strojarnice, te sunčališta po potrebama investitora. Nakon toga slijedi izvedba predgotovljenog kostura bazena u tvornici te slaganje u segmentima na licu mjesta tj. na gradilištu prema statičkom proračunu iz glavnoga projekta bazena.',
                        img: 'bed_pool2-1.jpg'
                    },
                    {
                        title: 'Bazenska tehnika',
                        text: 'Dobavljanje i ugradnja kompletne bazenske tehnike u bazen prema zahtjevima investitora.',
                        img: 'bed_pool3-1.jpg'
                    },
                    {
                        title: 'Opločenje',
                        text: 'Opločenje obruba bazena prema zahtjevu investitora (kamen, keramika…) i kompletna izvedba sunčališta prema zahtjevima investitora.',
                        img: 'bed_pool4.jpg'
                    },
                    {
                        title: 'Tehnički pregled',
                        text: 'Priprema i rješavanje tehničkog pregleda bazena u skladu sa projektnom dokumentacijom nakon kojega se dobiva uporabna dozvola za bazen, te ucrtavanje u katastar.',
                        img: 'bed_pool5-1.jpg'
                    }
                ],
                infoItems: [
                    {
                        num: 5,
                        unit: '+',
                        frontUnit: '',
                        text: 'vrsta materijala'
                    },
                    {
                        num: 30,
                        unit: 'dana',
                        frontUnit: '',
                        text: 'za kompletnu izgradnju'
                    },
                    {
                        num: 5,
                        unit: '',
                        frontUnit: '',
                        text: 'godina garancije'
                    },
                    {
                        num: 100,
                        unit: '%',
                        frontUnit: '',
                        text: 'fleksibilnosti'
                    },
                    {
                        num: 30,
                        unit: '%',
                        frontUnit: '-',
                        text: 'manja cijena'
                    }
                ],
                btnText: 'pošalji upit'
            }
        },
        notFound: {
            title: 'stranica nije pronađena',
            text: 'S našim uslugama se više nikada ne osjećaj izgubljeno',
            btnText: 'naše usluge'
        },
        about: {
            title: 'Posjetite nas',
            subtitle: 'Stvaramo domove',
            text: 'Kreativnost, pristupačnost klijentima, tendencija novitetima, konstantna edukacija, kvaliteta izgradnje i stručnost naši su temelji na kojima gradimo nove društvene vrijednosti te zadovoljstvo naših klijenata i investitora. Bedrina projekt d.o.o. razvija se od 90-ih godina, a u svojoj bogatoj poslovnoj povijesti izgradili smo veliki broj građevinskih objekata. Proširenje ponude omogućilo nam je i izradu širokog spektra građevinskih i arhitektonskih projekata na području grada Poreča, Vrsara i Novigrada. Pristupačnost i profesionalnost čine okosnicu djelovanja Bedrina Projekta d.o.o., uvijek spremni savjetovati i postići ono najbolje od projekata, kako bi investitori i klijenti bili besprijekorno zadovoljni. ',
            founderTitle: 'osnivači',
            founderWork1: 'građevinarstvo',
            founderWork2: 'projektiranje',
            officeTitle: 'ured',
            contactTitle: 'kontakt brojevi',
            accountTitle: 'račun',
            adressTitle: 'adresa'
        },
        contact: {
            title: 'trebaju mi vaše usluge',
            categories: ['projektiranje', 'građevinarstvo', 'nadzor'],
            placehName: 'ime i prezime',
            placehCompany: 'naziv tvrtke',
            placehEmail: 'email',
            placehPhone: 'broj telefona',
            placehMessage: 'poruka',
            placehDropD: [
                ['Odaberite uslugu*', 'arhitektonsko', 'građevinsko', 'arhitektonsko + građevinsko'],
                ['Odaberite uslugu*', 'stambena gradnja', 'poslovna gradnja', 'izgradnja bazena', 'ostalo'],
                ['Odaberite uslugu*', 'stambene zgrade', 'poslovne zgrade', 'industrijske zgrade', 'ostalo']
            ],
            gdpr: 'Slažem se da se ovi podatci koriste u svrhu odgovaranja na upit',
            btnText: 'pošalji',
            btnSentText: 'poruka poslana',
            btnError: ['Dogodila se pogreška, pokušajte ponovno', 'Polja označena sa * su obavezna'],
            contactInfo: {
                title: 'kontaktiraj nas',
                infoItems: [
                    {
                        icon: 'bed_engineering.png',
                        title: 'građevina',
                        email: 'Goran@bedrinaprojekt.hr',
                        phone: '+385/98/912 4789',
                        btnText: 'Pošalji mail',
                        link: 'mailto:info@bedrinaprojekt.hr?Subject=Upit%20za%20građevinu'
                    },
                    {
                        icon: 'bed_architecture.png',
                        title: 'projektiranje',
                        email: 'Andrej@bedrinaprojekt.hr',
                        phone: '+385/99/234 5238',
                        btnText: 'Pošalji mail',
                        link: 'mailto:info@bedrinaprojekt.hr?Subject=Upit%20za%20projektiranje'
                    }
                ]
            }
        },
        references: {
            title: 'reference',
            filterTitle: 'filtriraj:',
            allFilterText: 'sve',
            btnText: 'prikaži više',
            partnersTitle: 'naši vjerni partneri',
            footerTitle1: 'i ja želim',
            footerTitle2: 'ovakav projekt',
            footerText: 'Imate ideju, želite izgraditi objekt? Bedrina projekt vaš je partner za vrhunsku izgradnju, podršku i savjetovanje. Obratite nam se s potpunim povjerenjem i ostvarit ćemo vaše stambene snove!',
            footerButton: 'kreni'
        },
        projectArchive: {
            title: 'arhiva projekta'
        },
        partners: {
        },
        modal: {
            purpose: 'Namjena',
            service: 'Usluga',
            location: 'Lokacija',
            year: 'Godina',
            surface: 'Površina',
            investor: 'Investitor'
        },
        footer: {
            btnText: 'Napravi prvi korak! Kontaktiraj nas',
            navTitle: 'Navigacija',
            findOutMoreTitle: 'Saznaj više',
            findOutMore: [
                {
                    title: 'Izgradnja bazena',
                    path: '/usluge#izgradnjabazena'
                },
                {
                    title: 'Upit za projekt',
                    path: '/kontakt'
                },
                {
                    title: 'Istaknuti projekt',
                    path: '/reference'
                }
            ],
            connectTitle: 'Poveži se'
        }
    },
    en: {
        header: [
            {
                title: 'Home',
                path: '/',
                exact: true
            },
            {
                title: 'Services',
                path: '/usluge',
                exact: true
            },
            {
                title: 'References',
                path: '/reference',
                exact: true
            },
            {
                title: 'Contact',
                path: '/kontakt',
                exact: false
            },
            {
                title: 'About us',
                path: '/onama',
                exact: true
            },
        ],
        landing: {
            title: 'bedrina projekt',
            title2: 'building homes',
            title3: 'building business',
            text: 'Bedrina Projekt takes care of all stages of the development of the facilities, with top support to our clients and investors, making building easier and creating satisfaction.',
            button: 'find out more',
            serviceTitle: 'our services',
            serviceGrid: [
                {
                    icon: 'bed_architecture.png',
                    title: 'Architectual planning',
                    text: 'We define client requests, including eight specific stages of the planning and design process, to match the project with required parameters.',
                    link: '/usluge#projektiranje'
                },
                {
                    icon: 'bed_engineering.png',
                    title: 'Professional construction',
                    text: 'We build houses, flats, business facilities, adapt and reconstruct existing facilities to the highest standards, offering a full range of services.',
                    link: '/usluge#gradevinarstvo'
                },
                {
                    icon: 'bed_oversight.png',
                    title: 'Project supervision',
                    text: 'Supervision over all types of building construction is based on compliance with building permits, laws and regulations and rules of the profession.',
                    link: '/usluge#nadzor'
                }
            ],
            serviceGridButton: 'More about services',
            handKeyTitle: 'TURN KEY SYSTEM',
            handKeyText: 'With the Turnkey system, we have the ability to complete the project\'s design to make the ordered project ready for final use, providing care for all stages of construction. We offer:',
            handKeyItems: [
                {
                    title: 'Complete project documentation',
                    items: ['Project idea', 'Main project for building permit', 'Execution project', 'Project and service bill']
                },
                {
                    title: 'Complete project execution',
                    items: ['Execution of all work from the initial permit to the complete design of the object', 'Technical examination for the use permit on which the building can be used in full functionality']
                }
            ],
            referencesTitle: 'references',
            referencesButton: 'all references',
            handKeyButton: 'send an inquiry',
            poolInfo: {
                title: 'pool construction',
                subtitle: 'Simple construction that saves time and money',
                text: 'With turn-key system, we design and build swimming pools from the initial project to the complete pool with all amenities.',
                speed: 'faster',
                price: 'lower price',
                buttonText: 'find out more'
            }
        },
        services: {
            title: 'our services',
            box1: {
                title: 'construction',
                text: 'We are dealing with building, adaptation and reconstruction of houses, flats, business facilities and facilities for the market',
                image: '/images/el/bed_construction.png',
                button: 'send an inquiry',
                items: [
                    {
                        title: 'Earthwork',
                        items: []
                    },
                    {
                        title: 'Armature and concrete',
                        items: []
                    },
                    {
                        title: 'Carpentry',
                        items: []
                    },
                    {
                        title: 'Masonry',
                        items: []
                    },
                    {
                        title: 'Roof works',
                        items: []
                    }
                ]
            },
            box2: {
                title: 'architectual planning',
                text: 'We are dealing with complete architectural and construction design',
                image: '/images/el/bed_floorplan.png',
                button: 'send an inquiry',
                items: [
                    {
                        title: 'Idea solution',
                        items: ['Building construction data', 'Functional and organizational timetables']
                    },
                    {
                        title: 'Project idea',
                        items: ['Analysis of fundamentals and conditions for construction', 'Development of a project concept with graphic views and analyzes', 'Estimation of investment costs']
                    },
                    {
                        title: 'Location permit',
                        items: []
                    },
                    {
                        title: 'Main project',
                        items: ['Creating a selected project solution', 'Graphic view of the entire object']
                    },
                    {
                        title: 'Building permit',
                        items: []
                    }
                ]
            },
            box3: {
                title: 'Project supervision',
                text: 'We are supervising all types of building construction.',
                image: '/images/el/bed_helmet.png',
                button: 'send an inquiry',
                items: [
                    {
                        title: 'Project supervision',
                        items: ['Construction compliance with construction permit', 'Conformity with construction law', 'Compliance with special regulations and rules of procedure']
                    },
                    {
                        title: 'Supervision of construction',
                        items: ['Supervision of construction and control of embedded materials', 'Creating calculations of performed works, control of quantity of materials embedded during construction of the facility']
                    },
                    {
                        title: 'Consultation',
                        items: []
                    }
                ]
            },
            poolConstruction: {
                title: 'pool construction',
                text: 'With the turn-key system, we design and build swimming pools from the initial project to the complete pool with all amenities.',
                items: [
                    {
                        title: 'Main project',
                        text: 'The main project includes an architectural project, a construction project and a pool project with all the necessary documentation to be delivered to the investor.',
                        img: 'bed_pool1-1.jpg'
                    },
                    {
                        title: 'Excavation',
                        text: 'Pool excavation in all categories of terrain, buffering the bottom of swimming pools, engine rooms, and sunbeds according to the needs of the investor. Subsequently, we set the pre-fabricated skeleton of the pool in the factory and we build it on the building site, according to the static budget from the main pool project.',
                        img: 'bed_pool2-1.jpg'
                    },
                    {
                        title: 'Pool technique',
                        text: 'Supply and installation of the complete pool technique in the pool according to the requirements of the investor.',
                        img: 'bed_pool3-1.jpg'
                    },
                    {
                        title: 'Plastering',
                        text: 'Plastering of the basin according to the request of the investor (stone, ceramics ...) and the complete design of the sunbathing area according to the requirements of the investor.',
                        img: 'bed_pool4.jpg'
                    },
                    {
                        title: 'Technical Review',
                        text: 'Preparation and solution of the pool technical inspection in accordance with the project documentation after which a pool permit obtained.',
                        img: 'bed_pool5-1.jpg'
                    }
                ],
                infoItems: [
                    {
                        num: 5,
                        unit: '+',
                        frontUnit: '',
                        text: 'materials'
                    },
                    {
                        num: 30,
                        unit: 'days',
                        frontUnit: '',
                        text: 'for construction'
                    },
                    {
                        num: 5,
                        unit: '',
                        frontUnit: '',
                        text: 'years warranty'
                    },
                    {
                        num: 100,
                        unit: '%',
                        frontUnit: '',
                        text: 'flexibility'
                    },
                    {
                        num: 30,
                        unit: '%',
                        frontUnit: '-',
                        text: 'lower price'
                    }
                ],
                btnText: 'send an inquiry'
            }
        },
        notFound: {
            title: 'page not found',
            text: 'With our services you will never feel lost again',
            btnText: 'our services'
        },
        about: {
            title: 'Visit us',
            subtitle: 'Building homes',
            text: 'Creativity, customer accessibility, innovation, constant education, quality of construction and expertise are our foundations for building new social values and the satisfaction of our clients and investors. Bedrina projekt d.o.o. has been developing since the 1990s, and in its rich business history we have built a large number of construction facilities. The extension of the offer made it possible to create a wide range of construction and architectural projects in the area of Poreč, Vrsar and Novigrad. Accessibility and professionalism are forming the backbone of the Bedrina Project, always ready to advise and achieve the best of the projects, so that investors and clients are perfectly satisfied.',
            founderTitle: 'founders',
            founderWork1: 'construction',
            founderWork2: 'architectual planning',
            officeTitle: 'office',
            contactTitle: 'contact numbers',
            accountTitle: 'account',
            adressTitle: 'adress'
        },
        contact: {
            title: 'I need your services',
            categories: ['architectual planning', 'construction', 'supervision'],
            placehName: 'name and surname',
            placehCompany: 'company name',
            placehEmail: 'email',
            placehPhone: 'phone number',
            placehMessage: 'message',
            placehDropD: [
                ['Choose a service*', 'architectual planning', 'construction planning', 'architectual + construction planning'],
                ['Choose a service*', 'housing construction', 'business construction', 'pool construction', 'other'],
                ['Choose a service*', 'houses', 'business buildings', 'industrial buildings', 'other']
            ],
            gdpr: 'I agree that this data is used for the purpose of answering the service query',
            btnText: 'send a message',
            btnSentText: 'message sent',
            btnError: ['There was an error, try again later', 'Fields with * are mandatory'],
            contactInfo: {
                title: 'contact us',
                infoItems: [
                    {
                        icon: 'bed_engineering.png',
                        title: 'construction',
                        email: 'Goran@bedrinaprojekt.hr',
                        phone: '+385/98/912 4789',
                        btnText: 'Send e-mail',
                        link: 'mailto:info@bedrinaprojekt.hr?Subject=Upit%20za%20građevinu'
                    },
                    {
                        icon: 'bed_architecture.png',
                        title: 'architectual planning',
                        email: 'Andrej@bedrinaprojekt.hr',
                        phone: '+385/99/234 5238',
                        btnText: 'send e-mail',
                        link: 'mailto:info@bedrinaprojekt.hr?Subject=Upit%20za%20projektiranje'
                    }
                ]
            }
        },
        references: {
            title: 'references',
            filterTitle: 'filter:',
            allFilterText: 'all',
            btnText: 'show more',
            partnersTitle: 'our partners',
            footerTitle1: 'I also want to',
            footerTitle2: 'build a project',
            footerText: 'You have an idea, you want to build something? Bedrina Projekt is your partner for quality building, support and consulting. Contact us with complete confidence and we will make your dreams come true! ',
            footerButton: 'go'
        },
        projectArchive: {
            title: 'project archive'
        },
        partners: {
        },
        modal: {
            purpose: 'Purpose',
            service: 'Service',
            location: 'Location',
            year: 'Year',
            surface: 'Area',
            investor: 'Investor'
        },
        footer: {
            btnText: 'Make your first move! Contact us.',
            navTitle: 'Pages',
            findOutMoreTitle: 'Find out more',
            findOutMore: [
                {
                    title: 'Pool construction',
                    path: '/usluge#izgradnjabazena'
                },
                {
                    title: 'Project inquiry',
                    path: '/kontakt'
                }
            ],
            connectTitle: 'Connect'
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/langData.js